import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_grid _grid-cols-2--m _gap-7 _ai-c _js-c" }
const _hoisted_2 = { class: "_flexcol _gap-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { class: "_flexcol _gap-7" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_themed_image, {
          src: "/content/images/static/performance-marketing/performance-marketing-start.svg",
          alt: "Your campaign deserves best-in-class marketing",
          class: "_js-c"
        }),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "gfu-hd gfu-hd--h2" }, "Your campaign deserves best-in-class marketing", -1 /* CACHED */)),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, " Adfound empowers creators to launch quick and easy ad campaigns on Meta, leveraging years of expertise and well-established ad accounts that were previously exclusive to select companies. Using advanced technology, we optimize campaigns 24/7 to ensure your budget is utilized as efficiently as possible. ", -1 /* CACHED */)),
          _createElementVNode("div", null, [
            _createVNode(_component_processing_button, {
              "is-processing": $props.isProcessing,
              theme: "accent",
              onClick: $options.onTryForFree,
              "data-qa": "try-adfound-button"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" Try Adfound ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-processing", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}